export const AGENT = 'Agent';
export const DIRECTS = 'Directs';
export const CREATE = 'Create';
export const EDIT = 'Edit';
export const RELIST = 'Relist';
